export default "__VITE_ASSET__Clb9zUVX__"